export default __webpack_public_path__ + "static/media/padel-silver-cover.a0edfe29.png";